import styled from '@emotion/styled'
import { ITheme } from 'application/utils/type'
import { Modal, Container, Spinner, Alert } from 'react-bootstrap'

export const WarningIcon = styled.img`
  label: WarningIcon;
  padding-right: 6px;
  margin-bottom: 3px;
`

export const TextAreaLength = styled.span`
  label: TextAreaLength;
  float: right;
  font-size: 12px;
  color: ${(props) => props.theme.colors.textDarkblack} !important;
  margin-top: 6px;
`
export const ContainingDiv = styled.div`
  label: ContainingDiv;
  margin-left: 12px;
  @media (max-width: 719px) {
    width: 100%;
    margin-left: 0px;
  }
`

export const StyledModal = styled(Modal)`
  label: StyledModal;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const StyledTextArea = styled.textarea`
  label: StyledTextArea;
  min-height: 110px;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: ${(props) => (props.theme.brand === 'Maxxia' ? 'none' : '')},
  border-left: ${(props) => (props.theme.brand === 'Maxxia' ? 'none' : '')},
  border-right: ${(props) => (props.theme.brand === 'Maxxia' ? 'none' : '')},
`

export const HeadingDiv = styled.div`
  label: HeadingDiv;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
`

export const MainSpan = styled.span`
  label: MainSpan;
  @media (max-width: 719px) {
    width: 100%;
    margin-left: 0px;
  }
`

export const ValueDiv = styled.div`
  label: ValueDiv;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 800 : 400)};
  > a {
    color: ${(props) =>
      props.theme.brand === 'Maxxia'
        ? props.theme.colors.grey2
        : props.theme.colors.primary};
    text-decoration: underline;
    font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 800 : 900)};
  }
`
